<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-7 mx-auto">
        <card>
          <div class="card-body card-block">
            <b-button v-b-modal.modal-1 class="btn btn-success col-md-10 offset-md-1 mt-2"><i class="fa fa-graduation-cap"></i>&nbsp; Tomar curso</b-button>
          </div>
        </card>
      </div>
      <div class="col-sm-12">
          <card :header-text="'Global de historias inspiradoras'">
            <template v-slot:card-header>
              <h5>{{ `Hola ${user.nombres}!` }}</h5>
              <router-link class="btn btn-small btn-action btn-success"
                :to="{ name: 'reportes-inspirados' }"
              >
                <i class="fa fa-list"></i>&nbsp;<span>Reportes inspirados</span>
              </router-link>
            </template>
            <div v-if="isLoading" class="spinner"></div>
            <div ref="mapContainer" class="googleMap"></div>
          </card>
        </div>
    </div>
    <b-modal id="modal-1" title="¡Importante!">
        <div class="text-center">
          <p class="my-4">Para iniciar el curso, debes registrarte como un usuario de nuestra plataforma de aprendizaje utilizando el mismo correo electrónico que acabas de ingresar en el sistema</p>
          <img src="../../images/popUpExplaination.png" alt="Vista de ejemplo de registro">
          <div class="col-md-12">
            <a href="https://redvolucion.asegest.com/login/index.php" target="_blank">
              <button type="button" class="btn-primary"><u>Ingresa aquí y crea tu cuenta en el botón indicado por la flecha roja</u></button>
            </a>
          </div>
          <p><small>¡Recuerda <b>utilizar el mismo correo electrónico</b>!</small></p>
          <p>Es muy importante que recuerdes tu clave de ingreso, la necesitarás cuando regreses a cargar tu historia inspiradora.</p>
          <h3>!Bienvenido!</h3>
        </div>
      <div slot="modal-footer">
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { obtenerHistoriasInspirados } from '../../api/admin'
import departamentos from '../../static-data/departamentosfull'
const google = window.google || {}

export default {
  data () {
    return {
      map: {},
      isLoading: true
    }
  },
  computed: {
    ...mapState('user', [
      'user'
    ]),
    markers () {
      return [
        { position: { lat: 10, lng: 10 } }
      ]
    },
    infoWindow () { return new google.maps.InfoWindow() },
    departamentos () {
      return departamentos
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onClickMarker (data) {
      // console.log(data)
    },
    async init () {
      const that = this
      const inspiradoresHistorias = await obtenerHistoriasInspirados()

      var bogota = { lat: 4.5980195, lng: -74.0782074 }
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        zoom: 6,
        center: bogota
      })

      this.departamentos.forEach(departamento => {
        const inspiradoresByDepartamento = inspiradoresHistorias.filter(inspirador => inspirador.doc.departamento.codigo === departamento.ID)

        if (!inspiradoresByDepartamento.length) return

        let countHistorias = 0

        inspiradoresByDepartamento.forEach(inspirador => {
          countHistorias += inspirador.doc.historias.length
        })
        that.addMarker(that.map, String(countHistorias), departamento)
      })
      this.isLoading = false
    },
    addMarker (map, label, departamento) {
      const that = this

      const marker = new google.maps.Marker({
        position: { lat: Number(departamento.LAT), lng: Number(departamento.LNG) },
        label: label,
        map: map
      })

      marker.addListener('click', function () {
        that.infoWindow.setContent(`${departamento.NOMBRE}: ${label} historias`)
        that.infoWindow.open(that.map, marker)
      })
    },
    showInfowindow (pos, content) {
      this.infoWindow.setPosition(pos)
      this.infoWindow.setContent(content)
      this.infoWindow.open(this.map)
      this.map.setCenter(pos)
    }
  }
}

</script>

<style>
  .googleMap {
    display: flex;
    width: 100%;
    min-height: 600px;
  }
</style>
